module.exports = __webpack_public_path__ + "static/media/de.4d7bac3b.svg";